import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Home from "./pages/Home";
import Upload from "./pages/Upload";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ContactUs from "./pages/Contactus";
import RootLayout from "./layout/RootLayout";
import ProtectedRoute from "./layout/ProtectedRoute";
import RedirectIfLoggedIn from "./layout/RedirectIfLoggedIn";

export default function App() {


const allroutes = createBrowserRouter([
  // { path: "/", element: <Navigate to="/dashboard" replace /> },

  {
    element: <RootLayout />,
    children: [
      {
        path: "dashboard",
        element: (
          <ProtectedRoute allowedUserTypes={[1,6,7]}>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "home",
        element: (
          <ProtectedRoute allowedUserTypes={[1,6,7]}>
            <Home />
          </ProtectedRoute>
        ),
      },
  
      {
        path: "upload",
        element: (
          <ProtectedRoute>
            <Upload />
          </ProtectedRoute>
        ),
      },
      {
        path: "contactus",
        element: (
          <ProtectedRoute allowedUserTypes={[1,6,7]}>
            <ContactUs />
          </ProtectedRoute>
        ),
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
  { path: "/", element:<RedirectIfLoggedIn>
        <Login />
      </RedirectIfLoggedIn> },
]);

  return (
    <>
      <RouterProvider router={allroutes} />
    </>
  );
}

